<template>
  <my-dialog
    @hideMask="$emit('update:shareDialogFlag', false)"
    :dialogFlag="shareDialogFlag"
    width="660px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="dialog_container">
      <div class="dialog_container_header">
        <h3 class="header_title">分享</h3>
        <div class="close_btn" @click="$emit('update:shareDialogFlag', false)">
          <img
            src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png"
            alt="关闭"
          />
        </div>
      </div>
      <!-- <div class="dialog_container_body">
        <div class="share_list">
          <div class="share_item" v-for="item in shareList" :key="item.title" v-show="item.show">
            <div class="share_item_top">
              <span class="share_item_top_title">{{ item.title }}：</span>
              <span class="share_item_top_body">{{ item.joinCode }}</span>
            </div>
            <div class="share_item_bottom" v-show="item.show">
              {{ item.explainText }}
            </div>
          </div>
        </div>
      </div> -->
      <div class="invite_body">
        <div class="invite_item">
          <h3 class="invite_item_title">{{ inviteTitle }}</h3>
          <p class="invite_item_time">
            <span class="title">课堂时间：</span>
            <span class="content">{{ liveTime }}</span>
          </p>
          <p class="invite_item_code">
            <span class="title">听课教室参加码：</span>
            <span class="content">{{ attendLectureCode }}</span>
          </p>
          <div class="invite_item_copy_btn" @click="handleCopy('attendLecture')">复制听课信息</div>
        </div>
        <div class="invite_item">
          <h3 class="invite_item_title">{{ inviteTitle }}</h3>
          <p class="invite_item_time">
            <span class="title">课堂时间：</span>
            <span class="content">{{ liveTime }}</span>
          </p>
          <p class="invite_item_code">
            <span class="title">课堂观摩参加码：</span>
            <span class="content">{{ viewEmulateCode }}</span>
          </p>
          <p class="invite_item_link">
            <span class="title">课堂观摩直播链接：</span>
            <span class="content">{{ viewEmulateUrl }}</span>
          </p>
          <div class="invite_item_copy_btn" @click="handleCopy('viewEmulate')">复制观摩信息</div>
        </div>
      </div>
      <div class="invite_footer">
        <div class="invite_footer_btn" @click="$emit('update:shareDialogFlag', false)">确定</div>
      </div>
    </div>
  </my-dialog>
</template>

<script>
import { timestampToDate, timestampToWeekDay } from '@/utils/tool'
export default {
  name: 'ShareDialog',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data() {
    return {
      shareList: [
        {
          title: '老师参加码',
          joinCode: '- -',
          explainText: '老师参加码只能发送给主讲老师，泄漏后可能造成直播异常',
          show: true
        },
        {
          title: '听课教室参加码',
          joinCode: '- -',
          explainText: '听课/互动教室的助教，在“知到-教师版”APP输入该参加码，加入直播课堂',
          show: true
        },
        {
          title: '观摩旁听参加码',
          joinCode: '- -',
          explainText: '个体学生，在“知到”APP输入该参加码，看直播、回放',
          show: true
        }
      ]
    }
  },
  props: {
    shareDialogFlag: {
      type: Boolean,
      default: false
    },
    rowDetail: {
      type: Object,
      default: {}
    }
  },
  watch: {
    shareDialogFlag: function (newVal) {
      if (!newVal) return
      const { teacherInviteCode, assistantInviteCode, studentInviteCode } = this.rowDetail
      this.shareList = this.shareList.map((item) => {
        let { title } = item
        switch (title) {
          case '老师参加码':
            item.joinCode = teacherInviteCode || '- -'
            break
          case '听课教室参加码':
            item.joinCode = assistantInviteCode || '- -'
            break
          case '观摩旁听参加码':
            item.joinCode = studentInviteCode || '- -'
            break
        }
        return item
      })
    }
  },
  computed: {
    inviteTitle: function () {
      if (!this.rowDetail || !Object.keys(this.rowDetail).length) return ''
      console.log(this.rowDetail, 'rowDetail_rowDetail_rowDetail_rowDetail')
      const { username, teacherName, liveName } = this.rowDetail
      return `${username || teacherName}老师给您发送“${liveName}”的课堂邀请`
    },
    liveTime: function () {
      if (!this.rowDetail || !Object.keys(this.rowDetail).length) return ''
      let { actualStartTime, actualEndTime } = this.rowDetail
      let { startTime: startTimeOld, endTime: endTimeOld } = this.rowDetail
      if (!actualStartTime) {
        actualStartTime = startTimeOld
      }
      if (!actualEndTime) {
        actualEndTime = endTimeOld
      }
      const resultActualStartTime = timestampToDate(actualStartTime)
      const resultActualEndTime = timestampToDate(actualEndTime)
      const date = resultActualStartTime.split(' ')[0].replace(/-/g, '/')
      const weekDay = timestampToWeekDay(actualStartTime)
      const startTime = resultActualStartTime.split(' ')[1].slice(0, 5)
      const endTime = resultActualEndTime.split(' ')[1].slice(0, 5)
      return `${date}（${weekDay}）${startTime}-${endTime}`
    },
    attendLectureCode: function () {
      if (!this.rowDetail || !Object.keys(this.rowDetail).length) return ''
      const { assistantInviteCode } = this.rowDetail
      return assistantInviteCode || ''
    },
    viewEmulateCode: function () {
      if (!this.rowDetail || !Object.keys(this.rowDetail).length) return ''
      const { studentInviteCode } = this.rowDetail
      return studentInviteCode || ''
    },
    viewEmulateUrl: function () {
      // return `https://tju-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${this.rowDetail.liveId}`
      return `https://zhs-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${this.rowDetail.liveId}`
    }
  },
  methods: {
    async copy(content) {
      this.$copyText(content).then(
        (e) => {
          this.$message.success('复制成功!')
        },
        (e) => {
          this.$message.error('复制失败!')
        }
      )
    },
    handleCopy(type) {
      let content = ''
      switch (type) {
        case 'attendLecture':
          content = `${this.inviteTitle}\n课堂时间：${this.liveTime}\n听课教室参加码：${this.attendLectureCode}`
          break
        case 'viewEmulate':
          content = `${this.inviteTitle}\n课堂时间：${this.liveTime}\n课堂观摩参加码：${this.viewEmulateCode}\n课堂观摩直播链接：${this.viewEmulateUrl}`
          break
      }
      this.copy(content)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_container {
  .dialog_container_header {
    width: 100%;
    height: 60px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    border-bottom: 1px solid #eaeaea;
    position: relative;
    .header_title {
      font-size: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    .close_btn {
      width: 12px;
      height: 12px;
      cursor: pointer;
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  // .dialog_container_body {
  //   width: 100%;
  //   height: auto;
  //   padding: 20px 30px 10px;
  //   border-radius: 0 0 10px 10px;
  //   .share_list {
  //     .share_item {
  //       width: 100%;
  //       height: auto;
  //       padding-bottom: 10px;
  //       margin-bottom: 20px;
  //       .share_item_top {
  //         font-weight: bold;
  //         font-size: 14px;
  //         position: relative;
  //         padding-left: 10px;
  //         &::before {
  //           content: '';
  //           width: 3px;
  //           height: 16px;
  //           background-color: #1a90ff;
  //           border-radius: 2px;
  //           position: absolute;
  //           left: 0;
  //           top: 50%;
  //           transform: translateY(-50%);
  //         }
  //         .share_item_top_body {
  //           color: #2090ff;
  //         }
  //       }
  //       .share_item_bottom {
  //         font-size: 14px;
  //         color: #858492;
  //         margin-top: 6px;
  //       }
  //       &:nth-of-type(1) {
  //         .share_item_bottom {
  //           color: #fe7c14;
  //         }
  //       }
  //     }
  //   }
  // }
  .invite_body {
    width: 100%;
    height: 380px;
    padding: 30px;
    font-size: 14px;
    color: #1e2228;
    .invite_item {
      &:nth-of-type(2) {
        margin-top: 32px;
      }
      .invite_item_title {
        font-weight: 400;
        font-size: 14px;
      }
      .invite_item_time {
        margin-top: 8px;
      }
      .invite_item_code {
        margin-top: 8px;
      }
      .invite_item_link {
        margin-top: 8px;
        word-break: break-word;
        word-wrap: break-word;
      }
      .invite_item_copy_btn {
        width: 88px;
        height: 22px;
        background: #3982ff;
        border-radius: 2px;
        color: #fff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        margin-top: 11px;
        &:hover {
          background-color: #3369c7;
        }
        &:active {
          background: #3982ff;
        }
      }
    }
  }
  .invite_footer {
    width: 100%;
    height: 77px;
    border-top: 1px solid #e7e7e7;
    display: flex;
    justify-content: center;
    align-items: center;
    .invite_footer_btn {
      width: 116px;
      height: 38px;
      background: #3982ff;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      &:hover {
        background-color: #3369c7;
      }
      &:active {
        background: #3982ff;
      }
    }
  }
}
</style>
